export default "__VITE_ASSET__f31ccfcc__"